type EventActivityNoun = { singular: string; plural: string }

const nouns: Record<'encounter' | 'raid' | 'activity', EventActivityNoun> = {
  encounter: { singular: 'encounter', plural: 'encounters' },
  raid: { singular: 'raid', plural: 'raids' },
  activity: { singular: 'activity', plural: 'activities' },
}

export const eventActivityNoun = (
  activity: wowaudit.EventActivity,
): EventActivityNoun => {
  if (activity.encounter) return nouns.encounter
  return activity.activityType === 'raids' ? nouns.raid : nouns.activity
}

export const eventActivitiesNoun = (
  activities: wowaudit.EventActivity[],
): EventActivityNoun => {
  if (activities.some((activity) => activity.encounter)) return nouns.encounter
  return activities.every((activity) => activity.activityType === 'raids')
    ? nouns.raid
    : nouns.activity
}
